import useBankInfo from './useBankInfo';

export default useBankInfo;
